// extracted by mini-css-extract-plugin
module.exports = {"Tag":"_1p9Lv-mxmNsDW1_BZ-0-w9"};